import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PopoverOfflineIncidenciasMrPage } from './popover-offline-incidencias-mr.page';

const routes: Routes = [
  {
    path: '',
    component: PopoverOfflineIncidenciasMrPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PopoverOfflineIncidenciasMrPage]
})
export class PopoverOfflineIncidenciasMrPageModule {}
